import $ from 'jquery';

export default class MatomoFormTracking {
  constructor() {
    this.formSelector = '.webform-submission-form';
    // this.contactFormSelector = '.webform-submission-kontakformular-global-form';
    // this.contactFormVpfsSelector = '.webform-submission-kontaktformular-vpfs-form';
    // this.contactFormVpcslSelector = '.webform-submission-kontaktformular-vpcsl-form';
    this.orderFormSelector = '.webform-submission-bestell-formular-global-form';

    return this;
  }

  /**
     * Initialize function
     */
  init() {
    this.trackContactForms();
    this.trackOrderForms();

    return this;
  }

  trackContactForms() {
    const $forms = $(this.formSelector);

    $.each($forms, (index, form) => {
      const $form = $(form);
      $form.on('submit', () => {
        const formData = this.getFormData($form);
        const trackingData = {
          event: 'submitContactForm',
          'dlv-contactFormFieldIAm': formData.sie_sind || '',
          'dlv-contactFormFieldInterest': formData.dienstleistungen || '',
          'dlv-contactFormFieldCountry': formData['land[country]'] || '',
        };
        this.track(trackingData);
      });
    });
  }

  trackOrderForms() {
    const $forms = $(this.orderFormSelector);

    $.each($forms, (index, form) => {
      const $form = $(form);
      $form.on('submit', () => {
        const formData = this.getFormData($form);
        const trackingData = {
          event: 'submitOrderForm',
        };

        const products = formData.bestellungen
          .split('\n')
          .filter(Boolean);

        products.forEach((product, i) => {
          const orderIndex = i + 1;
          trackingData[`dlv-orderFormItem${orderIndex}`] = product;
        });

        this.track(trackingData);
      });
    });
  }

  track(trackingData) {
    // eslint-disable-next-line no-underscore-dangle
    window._mtm = window._mtm || [];
    // eslint-disable-next-line no-underscore-dangle
    window._mtm.push(trackingData);

    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  getFormData($form) {
    const serialized = $form.serializeArray();
    const formData = {};
    serialized.forEach((data) => {
      formData[data.name] = data.value;
    });

    return formData;
  }
}
